<div
  class="commonStyle"
>
  <app-cross-close-button></app-cross-close-button>
  <div
    class="headerStyle"
  >
    Выводить игроков в "Олимпийку"
  </div>
  <div
    class="containerOfOptions"
  >
    <div>
      <button
        class="btn btn-log btn-sm buttonExtraStyle"
        (click)="autoClickHandler()"
      >
        Автоматически
      </button>
    </div>
    <div>
      <button
        class="btn btn-log btn-sm buttonExtraStyle"
        (click)="manualClickHandler()"
      >
        Вручную
      </button>
    </div>
  </div>
</div>
